import SceneObject from "../../../lib/services/scene/sceneobject";
import ShaderService from "../../../lib/services/shader/shader_service";
import PlaneRenderPipeline from "../../../lib/services/render/pipelines/plane_renderpipeline";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";
import Transform from "../../../lib/services/render/transform";
import GroundPatch from "./ground_patch";
import Haze from "./haze";

export default class Ground extends SceneObject {
  base_pipeline: PlaneRenderPipeline;
  hazelist: Haze[] =[];
  patches:GroundPatch[] = [];
  base_transform: Transform;


  constructor(key: string) {
    super(key);

    // 1. Base ground — flat, large, the collision/walking surface.
    this.base_pipeline = new PlaneRenderPipeline(
      "ground_base",
      "unlit_texture",
      "ground",     // your existing desaturated base grass texture
      32, 32
    );

      // 2. Foreground overlay — grass tufts, daisies, dirt patches.
    // Uses alpha so the transparent gaps reveal the base ground beneath.
    

    const GROUND_Z = -0.005;
    
   
    type Patch = {
    x: number;
    y: number;
    z: number;
    scale: number;
    yaw: number;
    tex: string;
  };

  const patches: Patch[] = [
  // ============================================================
  // Dirt patches — anchor the puppy's hangout zone
  // ============================================================
  {x: -0.80, y: GROUND_Z + 0.004, z:  2.77, scale: 1.55, yaw: 3.22,                    tex: "dirt_patch_circle"},
  // small secondary dirt patch near the eat spot (where he drops the frisbee)
  {x:  0.55, y: GROUND_Z + 0.004, z:  6.00, scale: 0.85, yaw: 1.10,                    tex: "dirt_patch_circle"},

  // ============================================================
  // Foreground grass — denser near the camera edges,
  // sparser inside the dirt zone
  // ============================================================

  // Front-left foreground (closest to camera, leftmost)
  {x: -5.50, y: GROUND_Z + 0.001, z:  7.50, scale: 1.1,  yaw: 0.0,                      tex: "grass_patch"},
  {x: -3.80, y: GROUND_Z + 0.002, z:  7.20, scale: 1.0,  yaw: Math.PI * 0.5,            tex: "grass_patch"},
  {x: -2.00, y: GROUND_Z + 0.003, z:  7.40, scale: 0.95, yaw: Math.PI,                  tex: "grass_patch"},

  // Front-center
  {x:  0.20, y: GROUND_Z + 0.002, z:  7.80, scale: 1.05, yaw: Math.PI * 1.5,            tex: "grass_patch"},
  {x:  2.10, y: GROUND_Z + 0.001, z:  7.30, scale: 0.95, yaw: Math.PI * 0.25,           tex: "grass_patch"},
  {x:  3.90, y: GROUND_Z + 0.003, z:  7.10, scale: 1.0,  yaw: Math.PI * 0.75,           tex: "grass_patch"},
  {x:  5.40, y: GROUND_Z + 0.002, z:  7.60, scale: 1.1,  yaw: Math.PI * 1.25,           tex: "grass_patch"},

  // Midground sides (frame the play area)
  {x: -5.20, y: GROUND_Z + 0.001, z:  5.00, scale: 0.9,  yaw: Math.PI * 0.5,            tex: "grass_patch"},
  {x: -4.20, y: GROUND_Z + 0.002, z:  3.50, scale: 0.85, yaw: Math.PI * 1.0,            tex: "grass_patch"},
  {x:  4.50, y: GROUND_Z + 0.001, z:  5.20, scale: 0.95, yaw: Math.PI * 1.5,            tex: "grass_patch"},
  {x:  5.10, y: GROUND_Z + 0.002, z:  3.40, scale: 0.85, yaw: Math.PI * 0.25,           tex: "grass_patch"},

  // Around the dirt patch (just outside its edge)
  {x: -2.80, y: GROUND_Z + 0.001, z:  3.10, scale: 0.8,  yaw: Math.PI * 0.75,           tex: "grass_patch"},
  {x:  1.60, y: GROUND_Z + 0.002, z:  4.20, scale: 0.8,  yaw: Math.PI * 1.25,           tex: "grass_patch"},
  {x:  0.60, y: GROUND_Z + 0.003, z:  1.80, scale: 0.85, yaw: Math.PI * 1.75,           tex: "grass_patch"},
  {x: -2.40, y: GROUND_Z + 0.002, z:  4.70, scale: 0.75, yaw: Math.PI * 0.10,           tex: "grass_patch"},

  // Midground center-back (between dirt patch and mushroom cluster)
  {x: -1.20, y: GROUND_Z + 0.001, z:  0.50, scale: 0.85, yaw: Math.PI * 1.6,            tex: "grass_patch"},
  {x:  1.40, y: GROUND_Z + 0.002, z:  0.20, scale: 0.85, yaw: Math.PI * 0.4,            tex: "grass_patch"},
  {x:  3.20, y: GROUND_Z + 0.001, z:  1.80, scale: 0.8,  yaw: Math.PI * 0.9,            tex: "grass_patch"},
  {x: -3.00, y: GROUND_Z + 0.002, z:  1.40, scale: 0.8,  yaw: Math.PI * 1.4,            tex: "grass_patch"},

  // Background (behind the mushrooms, near forest base)
  {x: -4.80, y: GROUND_Z + 0.001, z: -1.50, scale: 0.7,  yaw: Math.PI * 0.5,            tex: "grass_patch"},
  {x: -2.50, y: GROUND_Z + 0.002, z: -2.20, scale: 0.7,  yaw: Math.PI * 1.0,            tex: "grass_patch"},
  {x:  0.40, y: GROUND_Z + 0.001, z: -2.80, scale: 0.65, yaw: Math.PI * 1.5,            tex: "grass_patch"},
  {x:  2.80, y: GROUND_Z + 0.002, z: -2.10, scale: 0.7,  yaw: Math.PI * 0.25,           tex: "grass_patch"},
  {x:  4.70, y: GROUND_Z + 0.001, z: -1.60, scale: 0.7,  yaw: Math.PI * 0.75,           tex: "grass_patch"},
];



  
    var patch_index = 0;  
    for (var i=0; i < patches.length;i++) 
    {
         const p = patches[i]; 
          const patch_key ="patch"+patch_index;
          const patch = new GroundPatch(patch_key,p.tex,2,2);
          const t = new Transform();
          patch.transform.set_position(p.x, p.y, p.z);
          patch.transform.set_rotation(0,  p.yaw , 0); // random yaw for variety
          patch.transform.set_scale(p.scale,p.scale, p.scale);
          patch.transform.update_matrix();
          this.add_child(patch);
          this.patches.push(patch);  
          patch_index++;
    }

    // 3. Distance haze — upright billboard at the horizon, alpha-fade to top.
    //-5.4
     var x = -14.4;
     for(var i = 0; i < 30; i++)
     {
       const haze = new Haze("haze",x);
       this.hazelist.push(haze);
         x+=1.0;
      }
    

    this.base_transform = new Transform();
    this.base_transform.set_position(0, GROUND_Z, 0);
    this.base_transform.set_rotation(0, 0, 0);
    this.base_transform.set_scale(1, 1, 1);
    this.base_transform.update_matrix();
 
  }

  async build(
    device: GPUDevice,
    format: GPUTextureFormat,
    shader_service: ShaderService,
    resource_service: ResourceService
  ): Promise<void> {
    await this.base_pipeline.build(device, format, shader_service, resource_service);
   
    for(var i=0; i< this.hazelist.length; i++)
    {
        await this.hazelist[i].build(device, format, shader_service, resource_service);
    }

    //foreground overlay are children
    super.build(device,format,shader_service,resource_service);


    // Haze billboard — vertical strip at the horizon.
    // Rotated so the plane stands upright facing the camera.
   
  }

  tick(delta_time: number): void 
  {
     //this.hazelist[0].placement.tick(delta_time);
     //this.patches[5].placement.tick(delta_time);
  }

  prepare(device: GPUDevice, camera: Camera): void {
    this.base_pipeline.prepare(device, camera, this.base_transform);
    for(var i=0; i< this.hazelist.length; i++)
    {
      this.hazelist[i].prepare(device, camera);
    }
    super.prepare(device,camera);
  }

  draw(pass: GPURenderPassEncoder): void {
    // Draw order matters for alpha:
    // 1. haze (alpha; reads from forest panel behind)
    // 2. base (opaque)
    // 3. foreground overlay (alpha; reads from base below)
    // 
   
    this.base_pipeline.draw(pass);
    super.draw(pass);
     for(var i=0; i< this.hazelist.length; i++)
     {
      this.hazelist[i].draw(pass);
     }
   
  }
}